
import { defineComponent } from 'vue';
import AppHeader from '../AppHeader.vue';
import DrivePhotoCarousel from '@/modules/drive/components/DrivePhotoCarousel.vue';
import DriveOverview from '@/modules/drive/components/ViewSubpages/DriveOverviewSubpage.vue';
import { useMainStore } from '@/store/mainStore';
import AppLoader from '../UI/AppLoader.vue';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    photoSkeletons: { type: Number, default: 0 },
    fileSkeletons: { type: Number, default: 0 },
  },
  components: {
    AppHeader,
    DrivePhotoCarousel,
    DriveOverview,
    AppLoader,
  },
  setup() {
    const mainStore = useMainStore();

    return {
      mainStore,
    };
  },
});
